import React, { useState } from 'react';
import { App, Spin } from 'antd';
import { agentConfigApi } from '../services/api-services';

const isDark = () => document.documentElement.classList.contains('theme-glass');

const preBg = () => isDark() ? 'rgba(255,255,255,0.06)' : '#f5f5f5';
const preBgBlue = () => isDark() ? 'rgba(99,140,255,0.1)' : '#f0f5ff';
const preBgError = () => isDark() ? 'rgba(255,77,79,0.1)' : '#fff2f0';
const subColor = () => isDark() ? 'rgba(255,255,255,0.5)' : '#666';

export const useTestProfile = () => {
  const { modal: appModal } = App.useApp();
  const [testing, setTesting] = useState(false);

  const testProfile = async (profileName: string) => {
    if (!profileName) return;
    const isSuperAdmin = (() => {
      try { return JSON.parse(localStorage.getItem('user') || '{}').role === 'super_admin'; } catch { return false; }
    })();
    setTesting(true);
    const testModal = appModal.info({
      title: '测试中...',
      width: 640,
      icon: null,
      okButtonProps: { style: { display: 'none' } },
      content: (
        <div style={{ textAlign: 'center', padding: '24px 0' }}>
          <Spin />
          <div style={{ marginTop: 12, color: subColor() }}>正在请求模型...</div>
        </div>
      ),
    });
    const start = Date.now();
    try {
      const res: any = await agentConfigApi.testGlobalProfile(profileName);
      const elapsed = Date.now() - start;
      const curl = isSuperAdmin ? res.curl : (res.curl || '').replace(/(Bearer\s+)\S+/i, '$1****');
      testModal.update({
        title: '✅ 测试成功',
        icon: null,
        okButtonProps: { style: {} },
        content: (
          <div style={{ marginTop: 12 }}>
            <div style={{ marginBottom: 8 }}>耗时：<strong>{(elapsed / 1000).toFixed(2)}s</strong>（服务端：{res.elapsed_ms}ms）</div>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>Shell 命令：</div>
            <pre style={{ maxHeight: 120, overflow: 'auto', background: preBgBlue(), padding: 12, borderRadius: 6, fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{curl}</pre>
            <div style={{ marginTop: 12, marginBottom: 8, fontWeight: 500 }}>响应：</div>
            <pre style={{ maxHeight: 200, overflow: 'auto', background: preBg(), padding: 12, borderRadius: 6, fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{JSON.stringify(res.data, null, 2)}</pre>
          </div>
        ),
      });
    } catch (err: any) {
      const elapsed = Date.now() - start;
      const detail = err?.response?.data?.detail;
      const errMsg = typeof detail === 'object' ? detail?.message : detail || '测试失败';
      const rawCurl = typeof detail === 'object' ? detail?.curl : null;
      const errCurl = rawCurl && !isSuperAdmin ? rawCurl.replace(/(Bearer\s+)\S+/i, '$1****') : rawCurl;
      testModal.update({
        title: '❌ 测试失败',
        icon: null,
        okButtonProps: { style: {} },
        content: (
          <div style={{ marginTop: 12 }}>
            <div style={{ marginBottom: 8 }}>耗时：<strong>{(elapsed / 1000).toFixed(2)}s</strong></div>
            {errCurl && (<><div style={{ marginBottom: 8, fontWeight: 500 }}>Shell 命令：</div><pre style={{ maxHeight: 120, overflow: 'auto', background: preBgBlue(), padding: 12, borderRadius: 6, fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{errCurl}</pre></>)}
            <pre style={{ maxHeight: 300, overflow: 'auto', background: preBgError(), padding: 12, borderRadius: 6, fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-all', marginTop: 12 }}>{errMsg}</pre>
          </div>
        ),
      });
    } finally {
      setTesting(false);
    }
  };

  return { testProfile, testing };
};
